import { useContext } from 'react';
import { ElementStateContext } from './ElementStateContext';

export const useElementState = () => useContext(ElementStateContext);
